import * as actionTypes from 'constants/ActionTypes';
import _ from 'lodash';

const tcRequests = (
    state = {
        items: [],
        isLoaded: false,
    },
    action
) => {
    switch(action.type) {
        case actionTypes.GET_TC_REQUESTS.REQUEST:
            return {
                ...state,
                items: [],
                isLoaded: false,
            };
        case actionTypes.GET_TC_REQUESTS.SUCCESS:
            const items = action.data.data.map(item => {
                return {
                    ...item,
                };
            });

            return {
                ...state,
                ...action.data,
                isLoaded: true,
                items,
            };

        case actionTypes.GET_TC_REQUESTS.FAILURE:
            return {
                ...state,
                isLoaded: true,
            };

        case actionTypes.DELETE_TC_REQUEST.REQUEST: 
            return {
                ...state,
            };
        case actionTypes.DELETE_TC_REQUEST.SUCCESS: {
            const newState = _.cloneDeep(state);
    
            newState.items.forEach((item) => {
                if (item._id === action.tcRequestId) {
                    item.deleteBy = { email: action.email };
                    item.deleteAt = new Date();
                }
            });
    
            return newState;
        }
        case actionTypes.DELETE_TC_REQUEST.FAILURE: {
            const newState = _.cloneDeep(state);
    
            newState.items.forEach((item) => {
                if (item._id === action.tcRequestId) {
                    item.errors = action.errors;
                }
            });
    
            return newState;
        }
        default:
            return state;
        }
    };

export default tcRequests;



// WEBPACK FOOTER //
// ./app/reducers/tc/requests.js